export const PlusCircle = () => (
  <path
    d='M12.7 9.2C12.7 8.8134 12.3866 8.5 12 8.5C11.6134 8.5 11.3 8.8134 11.3 9.2V11.3H9.2C8.8134 11.3 8.5 11.6134 8.5 12C8.5 12.3866 8.8134 12.7 9.2 12.7H11.3V14.8C11.3 15.1866 11.6134 15.5 12 15.5C12.3866 15.5 12.7 15.1866 12.7 14.8V12.7H14.8C15.1866 12.7 15.5 12.3866 15.5 12C15.5 11.6134 15.1866 11.3 14.8 11.3H12.7V9.2ZM12 5C8.136 5 5 8.136 5 12C5 15.864 8.136 19 12 19C15.864 19 19 15.864 19 12C19 8.136 15.864 5 12 5ZM12 17.6C8.913 17.6 6.4 15.087 6.4 12C6.4 8.913 8.913 6.4 12 6.4C15.087 6.4 17.6 8.913 17.6 12C17.6 15.087 15.087 17.6 12 17.6Z'
    fill='currentColor'
  />
)
